import App from 'next/app';
import React from 'react';
import styled from 'styled-components';
import '@meetbutter/ui/src/themes/global.css';

import { AppBase } from '../components/AppBase';
import 'styles/global.css';
import { Hidden } from '@material-ui/core';

class MyApp extends App {
  render() {
    const { Component, pageProps } = this.props;

    return (
      <>
        <AppBase router={this.props.router}>
          <Component {...pageProps} />

          <Hidden mdDown>
            <DesktopFloatingProductHunt
              href="https://www.producthunt.com/posts/butter-4?utm_source=badge-top-post-badge&utm_medium=badge&utm_souce=badge-butter-4"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://api.producthunt.com/widgets/embed-image/v1/top-post-badge.svg?post_id=293943&theme=dark&period=daily"
                alt="Butter - All-in-one tool for the smoothest virtual workshops 🧈 | Product Hunt"
                width="250"
                height="54"
              />
            </DesktopFloatingProductHunt>
          </Hidden>
        </AppBase>
      </>
    );
  }
}

const DesktopFloatingProductHunt = styled.a`
  position: fixed;
  left: 32px;
  bottom: 32px;
`;

export default MyApp;
